<template>
    <div class="section-products row g-lg-3">
        <div v-for="product in latest_products" :key="product.id" class="col-20">
            <div class="card shadow-sm product-card mb-4">
                <img :src="cdn_url+'products/'+product.image+'?auto=format,enhance,compress&fit=crop&crop=faces&h=200&w=260'" class="card-img-top" alt="" />
                <div class="card-body p-2 p-lg-3 pb-0 pb-lg-0">
                    <span v-if="product.type_name" class="text-uppercase small fw-bold text-secondary">{{ product.type_name }}</span>
                    <a :href="'/'+lang+'/t/'+product.type+'/'+product.id+'/'+product.slug" class="product-title stretched-link">{{ product.title[lang] }}</a>
                </div>
                <div class="card-bottom d-md-flex justify-content-between px-2 pb-2 px-lg-3 pb-lg-3">
                    <div class="product-price mt-auto">
                        <div class="text-muted small">{{ translate('messages.startingfrom') }}</div>
                        <span v-if="product.sale_price > 0" class="fw-bold text-color-secondary fs-5">{{ product.sale_price }} &euro;</span>
                        <span v-else class="fw-bold fs-5">{{ product.price }} &euro;</span>
                        <span v-if="product.sale_price > 0" class="fs-5 price-old">{{ product.price }} &euro;</span>
                    </div>
                    <div class="product-rating rating-stars d-none d-md-block mt-auto pb-1">
                        <review-ratings v-if="website_review != 0" :rating="product.rating_average"></review-ratings>
                        <div v-if="product.rating_average > 0" class="small"><strong>{{ product.rating_average }}</strong> ({{ product.reviews_count }} {{ translate('messages.reviews') }})</div>
                        <div v-else class="small">{{ translate('messages.Noreviewsyet') }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center">
            <a :href="route_search" class="btn my-5 btn-lg button-primary button-outline shadow py-3 ps-5 pe-4 rounded-pill">
                <span class="fw-500">{{ translate('messages.seeallactivities') }}</span>
                <i class="bi bi-arrow-right ms-4"></i>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        lang: String,
        website_id: String,
        website_review: String,
        route_search: String
    },

    data() {
        return {
			loading: true,
            latest_products: [],
            page: 1,
            cdn_url: process.env.MIX_CDN_URL
        }
    },

    mounted() {
        this.latestActivities();
    },

    methods: {
        latestActivities()  {
            axios.get(process.env.MIX_API_URL+'/'+this.website_id+'/home')
                .then(({data}) => {
                    this.latest_products = data.latest_products.items;
                }).catch(error => console.log(error))
				.finally(() => this.loading = false);
        }
    }

}
</script>